import React, { useRef } from 'react';
import { useOutsideAlerter } from 'hooks';

function OutsideAlerter(props) {
  const { children, className } = props;

  const wrapperRef = useRef(null);
  useOutsideAlerter({ ...props, ref: wrapperRef });

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
}

export default OutsideAlerter;
